// 导入polyfill
import structuredClonePolyfill from '@ungap/structured-clone';

// 只有在全局作用域中不存在structuredClone时才添加polyfill
if (typeof window !== 'undefined' && !('structuredClone' in window)) {
  console.log('Adding structuredClone polyfill');
  window.structuredClone = (any, options) => {
    if (options != null) {
      return structuredClonePolyfill(any, options);
    } else {
      return any;
    }
  };
}
// 检查 Array.prototype.at 是否存在，如果不存在则添加实现
if (!Array.prototype.at) {
  // 添加 at 方法的 polyfill
  Array.prototype.at = function(n) {
    // 将输入转换为整数
    n = Math.trunc(n) || 0;
    // 允许负索引
    if (n < 0) n += this.length;
    // 边界检查
    if (n < 0 || n >= this.length) return undefined;
    // 返回索引对应的元素
    return this[n];
  };
  
  // 确保方法不可枚举
  Object.defineProperty(Array.prototype, 'at', {
    enumerable: false
  });
}

export default defineNuxtPlugin(() => {
  console.log('structuredClone polyfill loaded');
}); 